import { MANUFACTURER_ACCOUNT_PASSWORD_MIN_LENGTH } from "static/constants";
import * as Yup from "yup";

export const changePasswordValidationSchema = Yup.object({
  currentPassword: Yup.string().required("Current Password is required"),
  newPassword: Yup.string()
    .required("New Password is required")
    .min(
      MANUFACTURER_ACCOUNT_PASSWORD_MIN_LENGTH,
      `New password has to be atleast ${MANUFACTURER_ACCOUNT_PASSWORD_MIN_LENGTH} characters long.`
    ),
  confirmNewPassword: Yup.string()
    .required("Confirm new password is required")
    .oneOf(
      [Yup.ref("newPassword"), null],
      "Confirm password must match the new password."
    ),
});
